/**
 * Do not edit directly
 * Generated on Fri, 26 Jan 2024 09:10:52 GMT
 */

export const SbFontWeightRegular = '400'
export const SbFontWeightMedium = '600'
export const SbFontWeightBold = '700'
